import { render, staticRenderFns } from "./ChemicalResultTable.vue?vue&type=template&id=c530e2d6&scoped=true"
import script from "./ChemicalResultTable.vue?vue&type=script&lang=js"
export * from "./ChemicalResultTable.vue?vue&type=script&lang=js"
import style0 from "./ChemicalResultTable.vue?vue&type=style&index=0&id=c530e2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c530e2d6",
  null
  
)

export default component.exports